import * as types from './constants';

const initialState = {
  data: {},
  getLoading: false,
  editLoading: false,
  errors_api: {}
};

const actions = {
  // Get Promotion
  [types.GET_PROMOTION_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_PROMOTION_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      getLoading: false
    };

    return { ...data };
  },

  [types.GET_PROMOTION_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Update Promotion
  [types.UPDATE_PROMOTION_REQUEST]: state => {
    const data = {
      ...state,
      editLoading: true
    };

    return { ...data };
  },

  [types.UPDATE_PROMOTION_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.UPDATE_PROMOTION_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.UPDATE_PROMOTION_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

